import React, { useCallback, useEffect, useState } from "react";
import { MdError, MdMoreVert } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaFacebook, FaHeart, FaShare, FaWhatsapp } from "react-icons/fa";
import { BsChatDots, BsCheck } from "react-icons/bs";
import Comment from "../molecules/Comment";
import "../../styles/custom.css";
import Reaction from "../molecules/Reaction/Reaction";
import { GoDotFill } from "react-icons/go";
import ProfileIMG from "../../assets/others/avatar.jpeg";
import { useAppDispatch, useAppSelector } from "../../redux/ReduxType";
import { useMakeRequest } from "../../hooks/useMakeRequest";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { commentSchema } from "../../validation/post.schema";
import { COMMENT_URL, POST_URL } from "../../constant/resource";
import { toast } from "sonner";
import LoaderSpinner from "../molecules/Loader/Loader.spinner";
import { timeAgo } from "../../utils/day.format";
// import { setPosts } from "../../redux/slice/post.slice";
import {
  addComment,
  deletePost,
  handleLike,
} from "../../redux/slice/post.slice";
import { SiSimpleanalytics } from "react-icons/si";
import CustomModal from "../modal/CustomModal";
import { CgUserAdd } from "react-icons/cg";
import MainModal from "../modal/Second.modal";
import { FaXTwitter } from "react-icons/fa6";
import { IoLinkOutline } from "react-icons/io5";
import { handleSocial } from "../../utils/sharePost";
import { Post } from "../../type/post.type";
// import { useDispatch } from "react-redux";

interface IFeedProps {
  isDark: boolean;
  data?: Post;
  showAll: boolean;
  refetch?: () => void;
}

const Feed: React.FC<IFeedProps> = ({ isDark, data, showAll, refetch }) => {
  const postId = data?._id;
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);
  const [friendModal, setFriendModal] = useState(false);
  const [canEran, setCanEarn] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const baseURL = `${process.env.REACT_APP_BASE_URL}/post/${postId}`;
  const makeRequest = useMakeRequest();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: { post: postId, author: user?._id },
    resolver: yupResolver(commentSchema),
  });
  // const currentWord = watch("content");

  const handleShow = () => navigate(`/post/${postId}`);
  const handleCopy = async (url: string) => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied");
    } catch (error) {
      console.log(error);
    }
  };
  const handleViewPost = (postId: string) => navigate(`/post/${postId}`);
  const handleShare = () => setShareModal(true);

  const handleLikePost = () => {
    if (!user?._id) {
      toast.error("Sign in to continue");
      navigate("/register");
      return;
    }
    const onSuccess = (data: any) => {
      const userId = user?._id;
      const postId = data.data?._id || data?._id;
      if (!userId && !postId) return;
      dispatch(handleLike({ userId, postId }));
    };
    const payload = { userId: user._id, postId: data?._id };
    makeRequest(
      POST_URL + "/like",
      "POST",
      payload,
      onSuccess,
      () => toast.error("Failed to like post"),
      () => {}
    );
  };
  const handleShowComment = (comment: any) =>
    showAll ? (
      comment?.comment?.map((eachComment: any) => (
        <Comment
          isDark={isDark}
          key={eachComment._id}
          id={eachComment?._id}
          name={eachComment?.author?.fullname}
          authorId={eachComment?.author?._id}
          imgSrc={eachComment?.author?.avatar}
          timestamp={eachComment?.created_at}
          content={eachComment?.content}
          likes={eachComment?.likes}
          dislikes={eachComment?.dislikes}
        />
      ))
    ) : (
      <Comment
        isDark={isDark}
        id={comment?.comment[0]?._id}
        name={comment?.comment[0]?.author?.fullname}
        authorId={comment?.comment[0]?.author?._id}
        imgSrc={comment?.comment[0]?.author?.avatar}
        timestamp={comment?.comment[0]?.created_at}
        content={comment?.comment[0]?.content}
        likes={comment?.comment[0]?.likes}
        dislikes={comment?.comment[0]?.dislikes}
      />
    );
  const handleMakeComment = useCallback(
    (formData: any) => {
      if (!user?._id) {
        toast.error("Sign in to comment");
        navigate("/register");
        return;
      }
      setLoading(true);
      const onSuccess = (commentData: any) => {
        toast.success("Comment posted");
        const id = postId;
        const comment = commentData.data;
        console.log("id", id, "comment", comment);
        dispatch(addComment(comment));
      };
      makeRequest(COMMENT_URL, "POST", formData, onSuccess, console.log, () => {
        reset();
        setLoading(false);
      });
    },
    [makeRequest, reset, user, navigate, postId]
  );
  const handleProfile = () =>
    navigate(
      user?._id === data?.author?._id
        ? `/profile`
        : `/user/${data?.author?._id}`
    );
  const handleMessage = () => {
    if (!user?._id) {
      toast.error("Sign in to message user");
      navigate("/register");
      return;
    }
    data?.author?.friends?.includes(user?._id)
      ? navigate(`/chat`)
      : setFriendModal(true);
  };
  const handleEarn = () => {
    if (!Array.isArray(user?.followers) && user?.followers !== "undefined")
      return;
    user?.followers?.length >= 1000
      ? setCanEarn(true)
      : navigate(`/single-earn/${data?._id}`);
  };
  const handleDeletePost = () => {
    if (!user) return toast.error("Sign in to continue");
    makeRequest(
      POST_URL + `/${data?._id}`,
      "DELETE",
      { userId: user._id, postId: data?._id },
      (data) => {
        toast.success("Post deleted");
        const post = data?.data;
        dispatch(deletePost(post?._id));
      },
      console.log,
      () => setLoading(false)
    );
  };
  const handleAdvertisePost = () => {
    if (!user?._id) {
      toast.error("Sign in to advertise post");
      navigate("/register");
      return;
    }
    navigate(`/register-post/${data?._id}`);
  };

  return (
    <div
      className={`rounded-lg shadow-sm mb-6 overflow-hidden ${
        isDark ? "bg-darkBg text-white" : "bg-white text-gray-900"
      }`}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center gap-3">
          <img
            onClick={handleProfile}
            className="w-10 h-10 rounded-full object-cover cursor-pointer ring-2 ring-gray-300 dark:ring-gray-600"
            src={data?.author?.avatar || ProfileIMG}
            alt="Profile"
          />
          <div>
            <div className="flex items-center gap-2">
              <span className="font-medium text-sm">
                {data?.author?.username}
              </span>
              <div className="flex -space-x-1">
                <BsCheck className="bg-blue-500 rounded-full w-4 h-4 text-white" />
                <BsCheck className="bg-green-500 rounded-full w-4 h-4 text-white" />
              </div>
            </div>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {timeAgo(data?.createdAt)}
            </p>
          </div>
        </div>
        <div className="dropdown dropdown-end relative">
          <div tabIndex={0} role="button">
            <MdMoreVert className="w-5 h-5 text-gray-600 dark:text-gray-300" />
          </div>
          <ul
            tabIndex={0}
            className={`dropdown-content menu rounded-lg shadow-lg w-40 p-2 ${
              isDark ? "bg-gray-700 text-white" : "bg-white text-gray-900"
            }`}
          >
            {/* {data?.author?._id !== user?._id &&
              !data?.author?.friends?.includes(user) && (
                <li>
                  <button>Connect</button>
                </li>
              )} */}
            {data?.author?._id !== user?._id && (
              <>
                <li>
                  <button>Report</button>
                </li>
                <li>
                  <button>Block</button>
                </li>
              </>
            )}
            {data?.author?._id === user?._id && (
              <>
                <li>
                  <button onClick={handleDeletePost}>Delete</button>
                </li>
                <li>
                  <button onClick={handleAdvertisePost}>Advertise</button>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>

      {/* Actions */}
      {data?.author?._id !== user?._id && (
        <div className="px-4 pb-2 flex items-center gap-6 text-sm">
          {user?._id && (
            <button
              onClick={handleEarn}
              className="flex items-center gap-1 hover:text-indigo-600"
            >
              <GoDotFill className="w-3 h-3" /> Earn
            </button>
          )}
          {user?._id && (
            <button
              onClick={handleMessage}
              className="flex items-center gap-1 hover:text-indigo-600"
            >
              <GoDotFill className="w-3 h-3" /> Message
            </button>
          )}
        </div>
      )}

      {/* Content */}
      <div className="p-4 pt-0">
        <p
          onClick={() => handleViewPost(data?._id as string)}
          className="text-base cursor-pointer line-clamp-3"
        >
          {data?.content}
        </p>
        {data?.media && (
          <img
            className={`mt-3 w-full rounded-md object-cover ${
              showAll ? "h-auto" : "h-80"
            }`}
            src={data?.media}
            alt="Post media"
          />
        )}
      </div>

      {/* Reactions */}
      <div className="px-4 py-2 flex items-center gap-6 border-t border-gray-200 dark:border-gray-700">
        <Reaction
          onClick={handleLikePost}
          title="Like"
          value={data?.likes?.length}
          isDark={isDark}
          logo={<FaHeart className="text-red-500 w-5 h-5" />}
        />
        <Reaction
          onClick={handleShow}
          title="Comment"
          value={data?.comment?.length}
          isDark={isDark}
          logo={
            <BsChatDots className="text-gray-500 dark:text-gray-400 w-5 h-5" />
          }
        />
        <Reaction
          onClick={handleShare}
          title="Share"
          value={data?.share?.length}
          isDark={isDark}
          logo={
            <FaShare className="text-gray-500 dark:text-gray-400 w-5 h-5" />
          }
        />
        <Reaction
          title="Views"
          value={data?.views?.length}
          isDark={isDark}
          logo={
            <SiSimpleanalytics className="text-gray-500 dark:text-gray-400 w-5 h-5" />
          }
        />
      </div>

      {/* Comment Section */}
      <div className="p-4">
        {data?.comment?.length ? (
          handleShowComment(data)
        ) : (
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Be the first to comment
          </p>
        )}
        <form
          onSubmit={handleSubmit(handleMakeComment)}
          className="mt-4 flex items-center gap-3"
        >
          <input
            type="text"
            className={`flex-1 px-4 py-2 rounded-md bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 outline-none focus:ring-2 focus:ring-indigo-500 ${
              errors.content
                ? "border-red-500 border"
                : "border-gray-300 dark:border-gray-600 border"
            }`}
            {...register("content")}
            placeholder="Write a comment..."
          />
          <button
            type="submit"
            className="px-4 py-2 rounded-md bg-indigo-600 text-white font-medium hover:bg-indigo-700 shadow-sm hover:shadow-md transition-shadow duration-200 disabled:opacity-50"
            disabled={loading}
          >
            {loading ? <LoaderSpinner color="white" /> : "Post"}
          </button>
        </form>
        {errors?.content && (
          <p className="text-red-500 text-sm mt-1">{errors.content.message}</p>
        )}
      </div>

      {/* Modals */}
      <CustomModal
        className=""
        isOpen={canEran}
        onClose={() => setCanEarn(false)}
        size="sm"
      >
        <div className="flex flex-col items-center gap-4 p-6 text-gray-900 dark:text-white">
          <MdError className="w-12 h-12 text-red-500" />
          <p className="text-base text-center">
            You need at least 1,000 followers to access this feature.
          </p>
        </div>
      </CustomModal>

      <CustomModal
        isOpen={friendModal}
        onClose={() => setFriendModal(false)}
        size="sm"
        className=""
      >
        <div className="flex flex-col items-center gap-4 p-6 text-gray-900 dark:text-white">
          <CgUserAdd className="w-12 h-12 text-indigo-600" />
          <p className="text-base text-center">
            You are not yet friends with this user.
          </p>
          <button className="px-6 py-2 rounded-md bg-indigo-600 text-white font-medium hover:bg-indigo-700 shadow-sm hover:shadow-md transition-shadow duration-200">
            Send Friend Request
          </button>
        </div>
      </CustomModal>

      <MainModal showModal={shareModal} closeModal={() => setShareModal(false)}>
        <div
          className={`${
            isDark ? "bg-gray-800 text-white" : "bg-white text-gray-900"
          } rounded-lg shadow-lg p-2`}
        >
          <div className="flex flex-col gap-1">
            <button
              onClick={() => handleCopy(baseURL)}
              className="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
            >
              <IoLinkOutline className="w-5 h-5" /> Copy Link
            </button>
            <button
              onClick={() =>
                handleSocial("Hot topic on Oosh", baseURL, "twitter")
              }
              className="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
            >
              <FaXTwitter className="w-5 h-5" /> X
            </button>
            <button
              onClick={() =>
                handleSocial("Hot topic on Oosh", baseURL, "facebook")
              }
              className="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
            >
              <FaFacebook className="w-5 h-5" /> Facebook
            </button>
            <button
              onClick={() =>
                handleSocial("Hot topic on Oosh", baseURL, "whatsApp")
              }
              className="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
            >
              <FaWhatsapp className="w-5 h-5" /> WhatsApp
            </button>
          </div>
        </div>
      </MainModal>
    </div>
  );
};

export default Feed;
